import { Reveal, MaskedLine } from "./Reveal";

export const Positioning = () => (
  <section className="relative px-5 py-28 sm:px-8 lg:py-40" data-testid="positioning-section">
    <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" />
    <div className="mx-auto max-w-5xl">
      <h2 className="font-display font-bold uppercase leading-[1.08] tracking-tight" data-testid="positioning-headline">
        <MaskedLine className="text-3xl text-ivory/40 sm:text-5xl">Non è dottrina.</MaskedLine>
        <MaskedLine delay={0.12} className="text-3xl text-ivory/40 sm:text-5xl">Non è motivazione cristiana.</MaskedLine>
        <MaskedLine delay={0.24} className="text-3xl text-ivory sm:text-5xl">
          Non è fitness <span className="text-gold">con un versetto sopra.</span>
        </MaskedLine>
      </h2>

      <div className="mt-16 grid gap-12 lg:grid-cols-2">
        <Reveal delay={0.2}>
          <p className="text-base leading-relaxed text-ivory/60 sm:text-lg">
            Fede & Fitness Italia nasce da una convinzione semplice:
          </p>
          <p className="mt-5 font-display text-2xl font-bold uppercase leading-tight tracking-wide text-ivory sm:text-3xl">
            La fede deve diventare <span className="text-gold">vita.</span>
          </p>
          <p className="mt-5 text-base leading-relaxed text-ivory/60 sm:text-lg">
            Vogliamo creare un ambiente nel quale fede, mente, corpo, relazioni, disciplina, formazione
            e vita reale possano finalmente incontrarsi.
          </p>
        </Reveal>

        <Reveal delay={0.35}>
          <figure className="relative border border-gold/25 bg-gold/[0.04] p-8 sm:p-10" data-testid="scripture-verse">
            <span className="absolute -top-5 left-8 font-serifq text-7xl italic text-gold">"</span>
            <blockquote className="font-serifq text-xl italic leading-relaxed text-ivory/90 sm:text-2xl">
              Il Dio della pace vi santifichi egli stesso completamente; e l'intero essere vostro,
              lo spirito, l'anima e il corpo…
            </blockquote>
            <figcaption className="mt-6 text-xs font-semibold uppercase tracking-[0.3em] text-gold">
              1 Tessalonicesi 5:23
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </div>
  </section>
);
